import domReady from "@roots/sage/client/dom-ready";

domReady(async () => {
  const el = document.querySelector('.anchors');

  if(el){
    const swiper = el.querySelector('.swiper').swiper;
    const btns = el.querySelectorAll('.btn');
    let activeBtn = null

    const activateButton = (entry) => {
      const el = entry.target;
      const index = Array.from(btns).findIndex(item => item.dataset.id === el.id)
      const btnEl = btns[index]

      if (btnEl) {
        if(activeBtn && activeBtn !== btnEl && entry.isIntersecting) {
          activeBtn.classList.remove('!font-bold', '!border-navy-0', '!shadow-navy-0', 'shadow-[inset_0_0_0_1px]')
          activeBtn.classList.add('!font-normal')
        }

        if (!entry.isIntersecting) {
          btnEl.classList.remove('!font-bold', '!border-navy-0', '!shadow-navy-0', 'shadow-[inset_0_0_0_1px]')
          btnEl.classList.add('!font-normal')
        } else {
          btnEl.classList.remove('!font-normal')
          btnEl.classList.add('!font-bold', '!border-navy-0', '!shadow-navy-0', 'shadow-[inset_0_0_0_1px]')

          if(entry.isIntersecting){
            swiper.slideTo(index)
          }

          activeBtn = btnEl
        }
      }
    };

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if(entry.intersectionRatio !== 0) {
          activateButton(entry);
        }
      });
    }, { threshold: [0.40] });

    btns.forEach((btn) => {
      const btnEl = document.getElementById(btn.dataset.id)

      if (btnEl) {
        observer.observe(btnEl);
      }
    })
  }
})
